/**
 * Created by Languagenut on 23/05/2019.
 */


import React  from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import {ButtonGroup , Breadcrumb , Table , ProgressBar  , Button , Card , Row  , Col } from 'react-bootstrap'
import {Bar} from 'react-chartjs-2';
import {DateRangePicker} from 'react-dates';
import ReportService from '../../services/reports-service.js';
import Translation from '../../store/internationalization-store.js';
import moment from  'moment'
import DetailedTable from './details/vocabulary.js';
import Downloader from '../../classes/download.js';

let colRanges = [
    {thresholdLower:70 , thresholdHigher:100 , total:0 , color:"#88c057"},
    {thresholdLower:40 , thresholdHigher:70  , total:0 , color:"#ffcc66"},
    {thresholdLower:1 , thresholdHigher:40   ,  total:0 , color:"#ed7161"},
    {thresholdLower:0 , thresholdHigher:0   ,  total:0 , color:"#ffffff"}
];



let ranges = [
    {thresholdLower:80 , thresholdHigher:100 , total:0 , color:"#88c057"},
    {thresholdLower:60 , thresholdHigher:80  , total:0 , color:"#abda81"},
    {thresholdLower:40 , thresholdHigher:60  , total:0 , color:"#ffcc66"},
    {thresholdLower:20 , thresholdHigher:40  , total:0  , color:"#f5988c"},
    {thresholdLower:0 , thresholdHigher:20   ,  total:0 , color:"#ed7161"}
];

export default class GradeBook extends React.Component {

    constructor(props) {
        super();
        this.history = [];
        this.props = props;
        this.MAX_BUTTON_LIMIT = 5;
        this.selectionIndex = 0;
        this.state = {
            startDate:moment().subtract(7, 'days'),
            endDate:moment(),
            modules:[],
            loaded:true,
        };
    }

    findHistoryIndex(screenUID){

        for(var idx = 0 ; idx < this.history.length; idx++ )
        {
            if(this.history[idx].screenID == screenUID ) return idx ;
        }

        return this.history.length;
    }

    search(screen , root , name){
        this.getResults(root , screen , name);
    }


    processRanges(data){

        var students = [];


        for(var idx = 0 ; idx < data.length; idx++)
        {
            var total = 0;
            var number = 0;
            for(var key in data[idx]) {
                if(!String(key).includes("average")) continue;

                total += Number(String(data[idx][key]).replace('%' , ''))
                ++number;
            }

            var n = (total/number);
            var avg = Math.floor(isNaN(n) ? 0 : n);
            students.push(avg)
        }

        var test = function(value , thresholdLower , thresholdHigher){

            if(value == 0 && thresholdLower == 0)
            {
                return true;
            }

            if(value == 100 && thresholdHigher == 100)
            {
                return true;
            }

            return value > Number(thresholdLower) && value <= Number(thresholdHigher)
        };

        for(var r = 0 ; r < ranges.length; r++)
            ranges[r].total = 0;

        for(var idx = 0 ; idx < students.length; idx++)
        {
            for(var r = 0 ; r < ranges.length; r++)
            {
                ranges[r].total +=  (test(Number(students[idx]) , ranges[r].thresholdLower , ranges[r].thresholdHigher) ? 1 : 0)
            }
        }

        console.log(ranges)

        return ranges;
    }


    getResults(isRoot , screenUID , crumbTranslation){
        this.history = this.history.slice(0, this.findHistoryIndex(screenUID));

        if(isRoot)
        {
            this.history = [];
        }

        this.history.push({name:crumbTranslation , screenID:screenUID});

        this.setState({loaded:false});

        console.log(screenUID);

        ReportService.getLanguageCourse(screenUID , this.props.language , this.state.startDate.unix() , this.state.endDate.unix() , this.props.classID , this.props.studentID).then(function(response){


            this.selectionIndex = 0;
            this.setState({
                primary:response.data,
                modules:response.modules.modules,
                loaded:true,
                ranges:this.processRanges(response.data),
                isDetail:false,
            })
        }.bind(this));
    }

    componentDidMount(){
        this.search(this.props.screen , true , Translation.get(12006 , 'Home'));
    }

    handleOnChange(value){

        this.setState({
            number:value
        })
    }

    getMainHeaders(columns , modules , notHTML){

        let head = [];

        let modulesHeader = modules.map(function(object , index ){

            if(notHTML)
            {
                return [String(Translation.getModule(object.title , object.forcedText)).replace(/,/g,"") , '']
            }
            else
            {
                if(object.screenUid)
                {
                    return <th  class="header_hyper" colspan={2} onClick={this.search.bind(this , object.screenUid , false , Translation.getModule(object.title ,object.forcedText))}><i class="fas fa-link"></i>&nbsp;{Translation.getModule(object.title , object.title)}</th>
                }
                else
                {
                    return <th  class="header_hyper" onClick={this.setDetailed.bind(this , object)} colspan={2} ><i class="fas fa-link"></i>&nbsp;{Translation.getModule(object.title , object.forcedText)}</th>
                }
            }


        }.bind(this));

        if(notHTML)
        {
            head.push([''].concat(modulesHeader));
        }
        else
        {
            head.push(<tr><th></th>{modulesHeader}</tr>);
        }


        let details = modules.map(function(object , index ){

            if(notHTML)
            {
                return [String(Translation.get(12223 , 'Average')).replace(/,/g,"") , String(Translation.get(12767 , 'Complete').replace(/,/g,""))]
            }

            return [<th width={'8%'}>{Translation.get(12223 , 'Average')}</th> , <th width={'8%'}>{Translation.get(12767 , 'Complete')}</th>]
        });

        if(notHTML)
        {
            head.push([''].concat(details));
        }
        else
        {
            head.push(<tr><th>{String(Translation.get(827 , 'Student Name'))}</th>{details}</tr>);
        }


        return head;
    }

    getRows(modules , notHTML){
        let rows = [];

        if(!this.state.primary) return [];


        for(var i = 0 ; i < this.state.primary.length; i++)
        {
            let modulesHeader = modules.map(function(object , index ){

                if(notHTML) return Translation.getModule(object.title , object.title);
                return <th colspan={2}>{Translation.getModule(object.title , object.title)}</th>
            });


            if(notHTML)
            {
                var cols = [this.state.primary[i].name];
            }
            else
            {
                var cols = [<td >{this.state.primary[i].name}</td>];
            }


            for(var j = 0 ; j < modules.length; j++)
            {

                var test = function(value , thresholdLower , thresholdHigher){

                    value = String(value).replace('%' , '');

                    if(value == 0 && thresholdLower == 0)
                    {
                        return true;
                    }

                    return value > Number(thresholdLower) && value <= Number(thresholdHigher)
                };

                let averagecol = null;

                for(var r = 0 ; r < colRanges.length; r++)
                {
                    if(test(this.state.primary[i]['module-'+modules[j].uid+'-average'] , colRanges[r].thresholdLower , colRanges[r].thresholdHigher))
                    {
                        averagecol = colRanges[r].color
                        break;
                    }
                }

                let completecol = null;

               /* for(var r = 0 ; r < colRanges.length; r++)
                {

                    if(test(this.state.primary[i]['module-'+modules[j].uid+'-completed'] , colRanges[r].thresholdLower , colRanges[r].thresholdHigher))
                    {
                        completecol = '#ffffff'
                        break;
                    }
                }*/


                if(notHTML)
                {
                    cols.push(this.state.primary[i]['module-'+modules[j].uid+'-average'] || '-');
                    cols.push(this.state.primary[i]['module-'+modules[j].uid+'-completed'] || '-');
                }
                else
                {
                    cols.push(<td style={{background:averagecol}}>{this.state.primary[i]['module-'+modules[j].uid+'-average'] || '-'}</td>)
                    cols.push(<td style={{background:completecol}}>{this.state.primary[i]['module-'+modules[j].uid+'-completed'] || '-'}</td>)

                }
            }

            if(notHTML)
            {
                rows.push(cols);
            }
            else
            {
                rows.push(<tr>{cols}</tr>);
            }

        }

        return rows;
    }

    getColums()
    {
        if(!this.state.primary)  return [];
        if(!this.state.primary[0])  return [];


        return [];
    }


    onDownloaded(){
        this.setState({
            triggerDownload:false,
        });
    }

    handelDownloadRequest(){


        if(this.state.isDetail)
        {
            this.setState({
                triggerDownload:true,
            });
            return
        }

        var csv = [];
        var row = [""];

        let headers = this.getMainHeaders([] , this.state.modules || [] , true)





        for(var i = 0 ; i < headers.length; i++)
        {
            csv.push(headers[i].join(","));
        }

        var r = this.getRows(this.state.modules || [] , true);


        for(var i = 0 ; i < r.length; i++)
        {
            csv.push(r[i].join(","));
        }

        (new Downloader()).download_csv(csv.join("\n"));
    }


    getPage(){
        return this.state.modules.slice(this.selectionIndex*this.MAX_BUTTON_LIMIT , (this.selectionIndex*this.MAX_BUTTON_LIMIT)+this.MAX_BUTTON_LIMIT)
    };

    isFirstSelection(){
        return this.selectionIndex == 0;
    };

    isLastSelection(){
        return (this.selectionIndex*this.MAX_BUTTON_LIMIT)+this.MAX_BUTTON_LIMIT >= this.state.modules.length;
    };

    onShift(offest){
        this.selectionIndex += offest;

        this.setState({
            isFirstSelection:this.isFirstSelection(),
            isLastSelection:this.isLastSelection(),
        });
    }

    getNavigationBreadcrumb(){

        let crumb = null;


       let btn =  <ButtonGroup className="float-right">
            <Button disabled={this.isFirstSelection()} onClick={this.onShift.bind(this , -1)}><i class="fas fa-arrow-left"></i></Button>
            <Button disabled={this.isLastSelection()} onClick={this.onShift.bind(this , 1)}><i class="fas fa-arrow-right"></i></Button>
        </ButtonGroup>


        if(this.state.isDetail)
        {
            crumb = <Breadcrumb.Item active={true} ><b>{Translation.getModuleNoIndexTranslation(this.state.module.title , this.state.module.title)}</b></Breadcrumb.Item>;
        }

        return <Breadcrumb>{this.history.map(function(crumb , index){

            var onClick =  this.getResults.bind(this , false , crumb.screenID , crumb.name)

            return <Breadcrumb.Item active={this.state.isDetail ? false : !(index != this.history.length - 1)} onClick={onClick} ><b>{crumb.name}</b></Breadcrumb.Item>

        }.bind(this))} {crumb} <div style={{position:'absolute' , left:'100%' , marginLeft:'-98px' , marginTop:'-8px'}}>{btn}</div></Breadcrumb>
    }

    getPrimaryTable(){
        if(!this.state.loaded) return <ProgressBar animated now={45} animated />


        if(this.state.isDetail)
        {
            return <Row>
                <Col md={12}>
                    {this.getNavigationBreadcrumb()}
                    {this.getTableDetail()}
                </Col>
            </Row>

        }

        let headers = this.getMainHeaders([] , this.getPage() || [])
        let body = this.getRows(this.getPage() || [] , false);

        return <Row>
            <Col md={12}>
                {this.getNavigationBreadcrumb()}
                <Table bordered={ true }>
                    <thead>
                    {headers}
                    </thead>
                    <tbody>
                    {body}
                    </tbody>
                </Table>
            </Col>
        </Row>
    }

    setDetailed(module){

        console.log(module);
        this.setState({
            isDetail:!this.state.isDetail,
            module:module
        })
    }

    getTableDetail(){
        return <DetailedTable onDownload={this.onDownloaded.bind(this)} triggerDownload={this.state.triggerDownload} set={this.state.startDate.unix()} due={this.state.endDate.unix()}  language={this.props.language}  studentID={this.props.studentID} classID={this.props.classID} onClick={this.setDetailed.bind(this , null)} module={this.state.module} />
    }

    getSecondaryTable(){
        if(!this.state.loaded || this.state.isDetail) return null

        const gradeColumns = [{
            dataField: 'thresholdLower',
            text: Translation.get(841 , 'From'),
            sort: true,
            align:'center',
            headerStyle: (colum, colIndex) => {
                return {textAlign:'center'};
            },
            formatter(cell){
                return <span>{cell}%</span>
            }
        },
            {
                dataField: 'thresholdHigher',
                text: Translation.get(840 , 'To'),
                sort: true,
                align:'center',
                headerStyle: (colum, colIndex) => {
                    return {textAlign:'center'};

                },
                formatter(cell){
                    return <span>{cell}%</span>
                }
            },
            {
                dataField: 'total',
                text: Translation.get(12672 , 'No. Students'),
                sort: true,
                align:'center',
                headerStyle: (colum, colIndex) => {
                    return {textAlign:'center'};

                }
            }];


        return <BootstrapTable filter={ filterFactory() } bordered={ false } keyField='id' data={ this.state.ranges || [] } columns={ gradeColumns } />;
    }


    getGraph(){
        if(!this.state.loaded || this.state.isDetail) return null

        let labels = []
        let data = []

        if(this.state.ranges)
        {
            labels = this.state.ranges.map(function(object){
                return String(object.thresholdLower) + '-' + String(object.thresholdHigher)
            });

            data = this.state.ranges.map(function(object){
                return Number(object.total)
            });


        }



        const barData = {
            labels: labels.reverse(),
            datasets: [
                {
                    backgroundColor: "rgba(17,173,205,1)",
                    borderColor:"rgba(17,173,205,1)",
                    borderWidth: 1,
                    data: data.reverse(),
                    yAxisID: 'y-axis-1',
                }
            ]
        };

        return      <Row>
            <Col md={12}>
                <Bar
                    data={barData}
                    width={100}
                    height={400}
                    options={ {
            responsive: true,
            legend:{
                display:false,
            },
            maintainAspectRatio: false,
            scales: {
                yAxes: [
                    {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                    },
                ]
            }
        }}
                    />
            </Col>
        </Row>
    }

    download(){

    }
    render(){
        let headers = this.getMainHeaders([] , this.getPage() || [])
        let body = this.getRows(this.getPage() || []);


        let search =   <div class="d-flex">
            <div style={{paddingRight:'10px' , paddingTop:'7px'}}>
                <DateRangePicker
                    displayFormat='DD/MM/YYYY'
                    isOutsideRange={() => false}
                    customArrowIcon={<i class="fas fa-arrows-alt-h"></i>}
                    startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                    startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
                    endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                    endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
                    onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
                    focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                    />
            </div>
            <div style={{paddingTop:".5rem"}}>
                <Button onClick={this.search.bind(this , this.props.screen , true , Translation.get(12006 , 'Home'))}>{Translation.get(595 , 'Search')}</Button>
                &nbsp;&nbsp;&nbsp;
                <Button onClick={this.handelDownloadRequest.bind(this)}>{Translation.get(826 , 'Download')}</Button>
            </div>

        </div>

        var extraData = "";

        if (this.props.classID != undefined && this.props.classID != null) {
            extraData = [<br/>,
                <Row>
                    <Col md={12}>
                        <b>{Translation.get(12673 , 'Student Results By Average Grade')}</b>
                    </Col>
                </Row>,
                <br/>,
                <Row>,
                    <Col md={6}>
                        {this.getSecondaryTable()}
                    </Col>
                    <Col md={6}>
                        {this.getGraph()}
                    </Col>
                </Row>]
        }

        return <div>
            <Row>
                <Col>
                    <Row>
                        <Col md={6}> {search}</Col>
                    </Row>
                    <br/>
                    <Card body>
                        {this.getPrimaryTable()}
                        {extraData}
                    </Card>

                </Col>
            </Row>
            <br/>
            </div>


    }

}